import { Paper } from "@mui/material"
import { ReportByClientItem } from "routes/sfg20-admin/plugins/system-info/reports-tab/report-by-client-item"
import { useState } from "react"
import { ReportClientSelector } from "routes/sfg20-admin/plugins/system-info/reports-tab/report-client-selector"
import { ReportHeader } from "routes/sfg20-admin/plugins/system-info/reports-tab/report-header"
import { Frag } from "lib/@components/slot/frag"

export function ReportByClient({ data, columns, title }) {
    const [client, setClient] = useState()
    let filteredData
    if (client) {
        filteredData = data.value.filter((row) => row.client === client.client)
    }

    return (
        <>
            <ReportClientSelector data={data.value} setClient={setClient} />

            {client && Object.entries(client).length ? (
                <Paper sx={{ padding: 2 }}>
                    <ReportHeader columns={columns} />
                    <ReportByClientItem
                        title={`${title} - ${client.clientName}`}
                        columns={columns}
                        item={filteredData[0]}
                    />
                </Paper>
            ) : (
                <Frag />
            )}
        </>
    )
}
